import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "../../utils/axios";
// utils

// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  fetchLoading: false,
  eventGallery: {
    data: [],
    meta: {
      total: 0,
    },
  },
};

// TODO: fetch all the eventGallery
export const fetchEventGallery = createAsyncThunk(
  "fetchEventGallery/eventGallery",
  async ({ enqueueSnackbar, limit = 10, page = 0, category_id }, thunkApi) => {
    try {
      const response = await axiosInstance.get(`gallery`, {
        params: {
          page: page + 1,
          limit,
          category_id,
        },
      });

      return {
        data: response.data.data,
        meta: {
          total: response.data.total,
        },
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: create eventGallery
export const createEventGallery = createAsyncThunk(
  "createEventGallery/eventGallery",
  async ({ data, enqueueSnackbar, handleClose }, thunkApi) => {
    try {
      const response = await axiosInstance.post(`gallery`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: update eventGallery
export const updateEventGallery = createAsyncThunk(
  "updateEventGallery/eventGallery",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      const response = await axiosInstance.patch(`gallery/${id}`, data);

      return {
        data: response.data.data,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete eventGallery
export const deleteEventImage = createAsyncThunk(
  "deleteEventImage/eventGallery",
  async ({ data, enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`gallery/media/${id}`, data);
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

// TODO: delete eventGallery
export const deleteEventGallery = createAsyncThunk(
  "deleteEventGallery/eventGallery",
  async ({ enqueueSnackbar, handleClose, id }, thunkApi) => {
    try {
      await axiosInstance.delete(`gallery/${id}`);
      return {
        data: id,
        handleClose,
        enqueueSnackbar,
      };
    } catch (error) {
      return thunkApi.rejectWithValue({ error, enqueueSnackbar });
    }
  }
);

const eventGallerylice = createSlice({
  name: "eventGallery",
  initialState,
  reducers: {
    resetEventGallery: (state) => {
      state.fetchLoading = false;
      state.isLoading = false;
    },
  },
  extraReducers: (builder) => {
    // TODO: create eventGallery
    builder.addCase(fetchEventGallery.pending, (state, _) => {
      state.fetchLoading = true;
    });

    builder.addCase(fetchEventGallery.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.eventGallery = action.payload;
    });

    builder.addCase(fetchEventGallery.rejected, (state, action) => {
      state.isLoading = false;
      state.fetchLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: create eventGallery
    builder.addCase(createEventGallery.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(createEventGallery.fulfilled, (state, action) => {
      state.isLoading = false;
      state.eventGallery.data = [
        action.payload.data,
        ...state.eventGallery.data,
      ];
      state.eventGallery.meta.total = state.eventGallery.meta.total + 1;
      action.payload.enqueueSnackbar("EventGallery is created successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(createEventGallery.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: update eventGallery
    builder.addCase(updateEventGallery.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(updateEventGallery.fulfilled, (state, action) => {
      state.isLoading = false;
      state.eventGallery.data = state.eventGallery.data.map((eventGallery) => {
        if (eventGallery.slug === action.payload.data.slug) {
          return action.payload.data;
        } else {
          return eventGallery;
        }
      });
      action.payload.enqueueSnackbar("EventGallery is updated successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(updateEventGallery.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    // TODO: delete eventGallery
    builder.addCase(deleteEventGallery.pending, (state, _) => {
      state.isLoading = true;
    });

    builder.addCase(deleteEventGallery.fulfilled, (state, action) => {
      state.isLoading = false;
      state.eventGallery.data = state.eventGallery.data.filter(
        (eventGallery) => eventGallery.id !== action.payload.data
      );
      action.payload.enqueueSnackbar("EventGallery is deleted successfully.", {
        variant: "success",
      });
      action.payload.handleClose && action.payload.handleClose();
    });

    builder.addCase(deleteEventGallery.rejected, (state, action) => {
      state.isLoading = false;
      action.payload.enqueueSnackbar(action.payload.error.message, {
        variant: "error",
      });
    });

    
  },
});

export default eventGallerylice.reducer;

export const { resetEventGallery } = eventGallerylice.actions;
